import React from 'react';
import InputField from '../components/InputField';
import styles from '../capitalExpenditure.module.scss';

const ThirdQuarter = ({ 
  row, 
  viewMode, 
  handleInputChange, 
  handleOperationalRowChange, 
  isOperational = false 
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  
  return (
    <>
      {/* Quarter 3 Columns */}
      <td className={styles.budgetCell}>
        <InputField
          value={row.q3BudgetDemand}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q3BudgetDemand', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q3AuthorityReceived}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q3AuthorityReceived', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q3Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q3Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q3Expense}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'q3Expense', englishValue || e.target.value)}
          placeholder="0"
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
      <td className={styles.budgetCell}>
        <InputField
          value={row.q3RemainingBalance}
          placeholder="0"
          readOnly={true}
          viewMode={viewMode}
          isNumeric={true}
        />
      </td>
    </>
  );
};

export default ThirdQuarter;
